<section *ngIf="loaded" class="pt-5 row">
  <div class="card card-shadow col-6 offset-3 mt-5">
    <div class="card-body">
      <!------------------------------>
      <!-- no timeclock files found -->
      <!------------------------------>
      <div *ngIf="!timeclockFiles || timeclockFiles?.length == 0">
        <h4 class="card-title">
          We could not find a TimeClock file for the period ending
          {{ pdis[0].PeriodEnd | date: 'MM/dd/yyyy' }}
        </h4>
      </div>
      <!------------------------------------------------------------>
      <!-- one valid timeclock file found. it could have warnings -->
      <!------------------------------------------------------------>
      <div *ngIf="timeclockFiles?.length == 1 && timeclockFiles[0].IsValid">
        <div class="d-flex align-items-center mb-3">
          <span class="relay-icon relay-icon--success-outline relay-icon--large"></span>
          <h4 class="ps-2">TimeClock file found</h4>
        </div>
        <p>
          You have a pending timeclock file for the pay period ending on
          {{ timeclockFiles[0].PeriodEndDate | date: 'MM/dd/yyyy' }}. Would you like to use one in
          your next payroll run?
        </p>
        <div
          class="p-3 bg-grey timeclock-message-scroll-container"
          *ngIf="timeclockFiles[0].Messages">
          <ul class="no-style mb-0">
            <li *ngFor="let warning of timeclockFiles[0].Messages">
              <span class="pe-2 relay-icon relay-icon--warning"></span>
              {{ warning.Message }}
            </li>
          </ul>
        </div>
      </div>
      <!-------------------------------------->
      <!-- one invalid timeclock file found -->
      <!-------------------------------------->
      <div *ngIf="timeclockFiles?.length == 1 && !timeclockFiles[0].IsValid">
        <div class="d-flex align-items-center mb-3">
          <span class="relay-icon relay-icon--error-outline relay-icon--large"></span>
          <h4 class="ps-2">You Have Errors in Your TimeClock File</h4>
        </div>
        <p *ngIf="!isCsr">
          Please get in touch with your payroll specialist, if you would like to import your
          TimeClock file into payroll.
        </p>
        <div *ngIf="isCsr">
          <p>
            In order to import your timesheet, please fix the following errors in the TimeClock
            application.
          </p>
          <ul
            class="no-style mb-0 p-2 bg-grey timeclock-message-scroll-container"
            *ngIf="timeclockFiles[0].Messages">
            <ng-container *ngFor="let errors of timeclockFiles[0].Messages">
              <li class="py-1">
                <span
                  class="pe-2 relay-icon"
                  [ngClass]="
                    errors.WarningLevel == warningLevels['Critical']
                      ? 'relay-icon--error'
                      : 'relay-icon--warning'
                  ">
                </span>
                {{ errors.Message }}
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
      <!------------------------------------------------------------------------>
      <!-- multiple timeclock files found. any with errors cannot be selected -->
      <!------------------------------------------------------------------------>
      <div *ngIf="timeclockFiles?.length > 1">
        <!-- radio button selection -->
        <div class="d-flex align-items-center mb-3">
          <span class="relay-icon relay-icon--success-outline relay-icon--large"></span>
          <h4 class="ps-2">
            Only one TimeClock file at a time can be imported to payroll.<br />Please select the
            file you would like to use below:
          </h4>
        </div>
        <div class="timeclock-message-scroll-container ps-5">
          <div *ngFor="let file of timeclockFiles; let i = index">
            <input
              [(ngModel)]="selTimeclockId"
              type="radio"
              id="timeclock-{{ i }}"
              [value]="file.Id || null"
              [disabled]="!file.IsValid"
              data-testid="timeclockOptions" />
            <label for="timeclock-{{ i }}"
              ><span></span> Schedule with period end {{ file.PeriodEndDate | date: 'MM/dd/yyyy' }}
            </label>
            <ul class="no-style mb-0 p-2 bg-grey" *ngIf="file?.Messages?.length">
              <ng-container *ngFor="let message of file.Messages">
                <li class="py-1">
                  <span
                    class="relay-icon pe-2"
                    [ngClass]="
                      message.WarningLevel == warningLevels['Critical']
                        ? 'relay-icon--error'
                        : 'relay-icon--warning'
                    ">
                  </span>
                  <span *ngIf="isCsr">
                    {{ message.Message }}
                  </span>
                  <span *ngIf="!isCsr">
                    There is an error with this TimeClock file. Please get in touch with your
                    payroll specialist, if you would like to import it into payroll.
                  </span>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
      <!-------------------->
      <!-- action buttons -->
      <!-------------------->
      <div class="pt-4 d-flex justify-content-end">
        <button
          cpGTagEvent
          [params]="{ event_label: 'timeclock_return_to_payroll_hub' }"
          class="btn btn-secondary"
          routerLink="/client/{{ clientCode }}/payroll-landing">
          Return to Payroll Hub
        </button>
        <button
          *ngIf="hasValidTimeclock"
          cpGTagEvent
          [params]="{ event_label: 'skip_timeclock_file_for_payroll' }"
          class="btn btn-secondary ms-2"
          (click)="runPayroll(false)">
          Skip this Step
        </button>
        <button
          *ngIf="hasValidTimeclock"
          cpGTagEvent
          [params]="{ event_label: 'use_timeclock_file_for_payroll' }"
          class="btn btn-primary ms-2"
          (click)="runPayroll(true)"
          [disabled]="!selTimeclockId">
          Use & Continue
        </button>
        <button
          *ngIf="!hasValidTimeclock"
          cpGTagEvent
          [params]="{ event_label: 'no_valid_timeclock_file_for_payroll' }"
          class="btn btn-primary ms-2"
          (click)="runPayroll(false)">
          Continue to Payroll
        </button>
      </div>
    </div>
  </div>
</section>
